import React from 'react';
import Badge from '../../../../components/common/Badge/Badge';
import Button from '../../../../components/common/Button/Button';
import DataTable from '../../../../components/common/DataTable/DataTable';
import ExerciseThumbnailImage from '../../../../components/common/ExerciseThumbnailImage/ExerciseThumbnailImage';
import Icon from '../../../../components/common/Icon/Icon';
import KebabMenu, { KebabMenuItem } from '../../../../components/common/KebabMenu/KebabMenu';
import LinkAction from '../../../../components/common/LinkAction/LinkAction';
import type { ExerciseItem } from '../../../../types/exercise';
import { formatDate } from '../../../../utils';
import styles from './ExerciseListRow.module.css';

interface ExerciseListRowProps {
  exercise: ExerciseItem;
  onView: (exercise: ExerciseItem) => void;
  onOpenVideo: (exercise: ExerciseItem) => void;
  menuItems: KebabMenuItem[];
}

const ExerciseListRow: React.FC<ExerciseListRowProps> = ({
  exercise,
  onView,
  onOpenVideo,
  menuItems,
}) => {
  const groups = exercise.group
    .split(/\s*[•,]\s*/)
    .map((item) => item.trim())
    .filter(Boolean);

  return (
  <DataTable.Row className={styles['exercise-row']}>
    <div className={styles['exercise-cell']}>
      <ExerciseThumbnailImage
        exerciseId={exercise.id}
        exerciseName={exercise.name}
        className={styles.thumbnail}
      />

      <div className={styles['exercise-content']}>
        <button
          type="button"
          className={styles['exercise-name-button']}
          title={exercise.name}
          onClick={() => onView(exercise)}
        >
          <span className={styles['exercise-name']}>{exercise.name}</span>
        </button>
      </div>
    </div>

    <div className={styles['group-cell']}>
      {groups.map((group) => (
        <Badge key={`${exercise.id}-${group}`} variant="info" className={styles['group-badge']}>
          {group}
        </Badge>
      ))}
    </div>

    <div className={styles['equipment-cell']} title={exercise.resistanceType}>
      {exercise.resistanceType}
    </div>

    <div className={styles['objective-cell']} title={exercise.objective}>
      {exercise.objective}
    </div>

    <div className={styles['video-cell']}>
      <LinkAction
        label="Ver vídeo"
        icon="play_circle"
        onClick={() => onOpenVideo(exercise)}
      />
    </div>

    <div className={styles['date-cell']}>
      <Icon name="calendar_month" size={16} className={styles['date-icon']} />
      <span>{formatDate(exercise.createdAt)}</span>
    </div>

    <div className={styles['actions-cell']}>
      <Button
        variant="primary"
        size="xs"
        className={styles['view-button']}
        onClick={() => onView(exercise)}
      >
        Ver
      </Button>

      {menuItems.length > 0 && (
        <div className={styles['kebab-wrapper']}>
          <KebabMenu items={menuItems} />
        </div>
      )}
    </div>
  </DataTable.Row>
  );
};

export default ExerciseListRow;